import type { GetInvoicePdfResponse } from '@weft/api-definition';
import { GetInvoicePdfResponseSchema } from '@weft/api-definition';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';

export function useInvoicePdf(invoiceId: string, options?: CustomUseQueryOptions<GetInvoicePdfResponse>) {
  return useQuery({
    queryKey: ['invoice-pdf', invoiceId],
    queryFn: async () => {
      const api = getPrivateApi();
      const response = await api.getInvoicePdf({ invoiceId });

      return GetInvoicePdfResponseSchema.parse(response);
    },
    ...options,
  });
}

export function useInvoicesPdfs(invoiceIds: string[]) {
  return useQuery({
    queryKey: ['invoices-pdfs', invoiceIds],
    queryFn: async () => {
      const api = getPrivateApi();
      const requests = invoiceIds.map((invoiceId) => {
        return api.getInvoicePdf({ invoiceId });
      });
      const responses = await Promise.all(requests);

      return responses.map((response) => GetInvoicePdfResponseSchema.parse(response));
    },
  });
}